<nav id="navbar" class="navbar navbar-expand-lg navbar-light py-3" [ngClass]="{'fixed-top':this.fixNavBar}">
  <div class="container-fluid">
    <img class="m-auto" src="assets/imgs/Bhavani_Negro.png" width="140" height="19" alt="Logo" />
  </div>
</nav>